module.exports = __webpack_public_path__ + "img/no template.f044cb4c.png";